module.exports = __webpack_public_path__ + "img/StartSearchIcon.f264c4ea.svg";